import { Button, Modal, Tabs } from "antd";
import React, { useState } from "react";
import { useItemsFine } from "../actions/app/items";
import styles from "./styles/NewModal.module.css";
import classNames from "classnames"
import { getCreateURL } from "../_helpers/editor";

function NewModal({ trigger = <Button>Create New</Button> }) {
    const [open, setOpen] = useState(false);
    const { isSuccess, isLoading, data } = useItemsFine("qdb_creation_type", "fields=*", open, false);
    const [selected_item, setSelectedItem] = useState(null);

    return <>
        <div onClick={() => setOpen(true)}>
            {trigger}
        </div>
        <Modal
            title="Create from scratch"
            open={open}
            onCancel={() => setOpen(false)}
            footer={[
                <Button key="back" onClick={() => setOpen(false)}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary"
                    disabled={!selected_item}
                    onClick={() => {
                        const url = getCreateURL(selected_item.id);
                        window.open(url, '_blank');
                        setOpen(false);
                    }}
                >
                    Create
                </Button>,
            ]}
        >
            <TabPaneGrid
                data={data}
                isLoading={isLoading}
                isSuccess={isSuccess}
                onSelect={item => {
                    setSelectedItem(item);
                }}
                selected_item={selected_item}
            />
            {/* <Tabs
                items={[
                    {
                        key: '1',
                        label: 'Social',
                        children: <TabPaneGrid data={data} isLoading={isLoading} isSuccess={isSuccess} />,
                    },
                    {
                        key: '2',
                        label: 'Marketing',
                        children: 'Content of Tab Pane 2',
                    },
                    {
                        key: '2',
                        label: 'Business',
                        children: 'Content of Tab Pane 2',
                    },
                    {
                        key: '3',
                        label: 'Print',
                        children: 'Content of Tab Pane 3',
                    },
                ]}
            /> */}
        </Modal>
    </>
}

export default NewModal;


function TabPaneGrid({ data, isLoading, isSuccess, onSelect, selected_item }) {
    return <div className={styles.grid_wrapper}>
        {isSuccess && data.filter(item => !!item.icon).map(item => (
            <div className={classNames({
                [styles.card]: true,
                [styles.selected]: selected_item?.id === item.id
            })} key={item.id}
                onClick={() => onSelect(item)}
            >
                <i className={classNames(styles.icon, item.icon)} />
                <div className={styles.name}>{item.name}</div>
                <div className={styles.size}>{item.width} {item.unit} x {item.height} {item.unit} </div>
            </div>))}
    </div>
}